import GameService from "./game-service";
import {
    eventRepository,
    matchRepository,
    playerRepository
} from "../storage/storage";
import TennisBoxScore from "../sports/tennis/stats/box-score";
import ContextService from "./context-service";
import BaseStatsService from "./base-stats-service";
import TeamService from "./team-service";

class TennisStatsService extends BaseStatsService {
    async getBoxScore(gameId) {
        const [game, gameContext, matches] = await Promise.all([
            GameService.getGame(gameId),
            ContextService.getGameContext(gameId),
            matchRepository.where({ gameId: gameId }).toArray()
        ]);

        const { homeTeamId, awayTeamId } = gameContext;

        const [event, homeTeam, homePlayers, awayTeam, awayPlayers] =
            await Promise.all([
                eventRepository.getById(game.eventId),
                TeamService.getTeam(homeTeamId),
                playerRepository
                    .where({
                        teamId: homeTeamId
                    })
                    .toArray(),
                TeamService.getTeam(awayTeamId),
                playerRepository
                    .where({
                        teamId: awayTeamId
                    })
                    .toArray()
            ]);

        const boxscore = new TennisBoxScore({
            gameContext,
            event,
            matches,
            homeTeam,
            homePlayers,
            awayTeam,
            awayPlayers
        });
        boxscore.calculate();
        return boxscore;
    }
}

export default new TennisStatsService();
